export interface CuotasMod {
    id: number;
    catCursoId: string;
    catEdicionesId: number;
    monto: any;
    codigoTipoCuenta: string;
    codigoTipoTransaccion: number;
    fechaCobroProgramado: any;
    aplicaenInscripcion: string;
    procesoCargosAplicado: string;
    fechaRegistro: any;
    usarioRegistra: string; 
   
   
}

export class CuotasMod implements CuotasMod {
    constructor(init?: CuotasModFormValues) {
        Object.assign(this, init);
    }
}

export class CuotasModFormValues {
    id: number = 0
    catCursoId: string = "";
    catEdicionesId: number = 0;
    monto: string = "";
    codigoTipoCuenta: string = "";
    codigoTipoTransaccion: number = 0;
    fechaCobroProgramado: Date | null = null;
    aplicaenInscripcion: string = "";
    procesoCargosAplicado: string = "";
    fechaRegistro: Date | null = null;
    usarioRegistra: string = "";
   
    
    constructor(CuotasMod?: CuotasModFormValues) {
        if (CuotasMod) {
            this.id = CuotasMod.id;
            this.catCursoId = CuotasMod.catCursoId;
            this.catEdicionesId = CuotasMod.catEdicionesId;
            this.monto = CuotasMod.monto;
            this.codigoTipoCuenta = CuotasMod.codigoTipoCuenta;
            this.codigoTipoTransaccion = CuotasMod.codigoTipoTransaccion;
            this.fechaCobroProgramado = CuotasMod.fechaCobroProgramado;                      
            this.aplicaenInscripcion = CuotasMod.aplicaenInscripcion;
            this.procesoCargosAplicado = CuotasMod.procesoCargosAplicado
            this.fechaRegistro = CuotasMod.fechaRegistro;           
            this.usarioRegistra = CuotasMod.usarioRegistra;
          
            
        }

    }
}

export interface CuotasConsulta {
    catcursoid: number;
    catedicionid: number;
   
   
}

export class CuotasConsulta implements CuotasConsulta {
    constructor(init?: CuotasConsultaFormValues) {
        Object.assign(this, init);
    }
}

export class CuotasConsultaFormValues {

    catcursoid: number = 0;
    catedicionid: number = 0;
    
   
    
    constructor(CuotasConsulta?: CuotasConsultaFormValues) {
        if (CuotasConsulta) {
            this.catcursoid = CuotasConsulta.catcursoid;
            this.catedicionid = CuotasConsulta.catedicionid;
           
          
            
        }

    }
}